// Shared by the homepage and CV so the portraits stay in sync.
export const profilePortrait = {
  src: "/images/fachu-dev-profile-web.png",
  alt: "Facundo Criscuolo",
};

// Add the new About portraits here when they are supplied.
export const aboutPortraits = [
  { src: "/images/fachu-darkvader.webp", alt: "Darth Vader figurine on a desk" },
  profilePortrait,
];
